import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import ru from './locales/ru.json'
import zh from './locales/zh.json'
import { DEFAULT_LANG } from '@shared/i18n/languages'

void i18n.use(initReactI18next).init({
  resources: {
    ru: { translation: ru },
    zh: { translation: zh },
  },
  lng: DEFAULT_LANG,
  fallbackLng: DEFAULT_LANG,
  interpolation: { escapeValue: false },
})

export default i18n
